/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetBreakSettingsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {BatchGetBreakSettingsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const batchGetBreakSettings = (request: BatchGetBreakSettingsRequest, options?: CashRequestOptions) => post<BatchGetBreakSettingsRequest, BatchGetBreakSettingsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/BatchGetBreakSettings", request, {...options, rejectOnError: true })